import { Component, OnInit } from "@angular/core";
import { UsersService } from "@shared/services/users/users.service";
import { WcmService } from "@shared/services/wcm/wcm.service";

@Component({
	selector: "app-server-maintenance",
	templateUrl: "./server-maintenance.component.html",
	styleUrl: "./server-maintenance.component.scss",
	standalone: false
})
export class ServerMaintenanceComponent implements OnInit {
	constructor(
		public wcmService: WcmService,
		public userService: UsersService
	) { }

	ngOnInit() {
		this.userService.resetProfile();
	}
}